export default __webpack_public_path__ + "static/media/ic_wglmr_40.5d7c0689.svg";